function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var GENERAL_ATTRIBUTE = 'data-cookie-consent';
var ACCEPTED_STATE_ATTRIBUTE = 'data-cookie-consent-accepted';
var REJECTED_STATE_ATTRIBUTE = 'data-cookie-consent-rejected';
/**
 * DOM toggler, which enables conditional script tags or embedded content.
 */

var DomToggler = function DomToggler(config) {
  /**
   * Append a single script.
   * @TODO append it to the same location and re-add classes and attributes.
   */
  var appendScript = function appendScript(script) {
    var newScript = document.createElement('script');

    if (script.src) {
      newScript.src = script.src;
    } else {
      newScript.innerHTML = script.innerHTML;
    }

    document.head.appendChild(newScript);
  };
  /**
   * Enable script tags.
   * Note: scripts are not removed for the current view when preferences are updated.
   */


  var toggleScripts = function toggleScripts(_ref) {
    var id = _ref.id,
        accepted = _ref.accepted;

    if (!accepted) {
      return;
    }

    var scripts = document.documentElement.querySelectorAll("script[".concat(GENERAL_ATTRIBUTE, "=\"").concat(id, "\"]"));

    _toConsumableArray(scripts).forEach(function (script) {
      appendScript(script);
      script.parentNode.removeChild(script);
    });
  };
  /**
   * Show a single iframe.
   */


  var showIframe = function showIframe(iframe) {
    var src = iframe.getAttribute('data-src');

    if (src) {
      iframe.setAttribute('src', src);
      iframe.removeAttribute('data-src');
    }
  };
  /**
   * Hide a single iframe.
   */


  var hideIframe = function hideIframe(iframe) {
    var src = iframe.getAttribute('src');

    if (src) {
      iframe.setAttribute('data-src', src);
      iframe.removeAttribute('src');
    }
  };
  /**
   * Show conditional iframes based on wanted state.
   */


  var toggleConditionalIframes = function toggleConditionalIframes(_ref2) {
    var id = _ref2.id,
        accepted = _ref2.accepted;
    var iframes = document.body.querySelectorAll("iframe[".concat(GENERAL_ATTRIBUTE, "=\"").concat(id, "\"]"));

    _toConsumableArray(iframes).forEach(function (el) {
      return accepted ? showIframe(el) : hideIframe(el);
    });
  };
  /**
   * Show a single element.
   */


  var showElement = function showElement(el) {
    el.style.display = '';
    el.removeAttribute('aria-hidden');
    el.removeAttribute('hidden');
  };
  /**
   * Hide a single element.
   */


  var hideElement = function hideElement(el) {
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
  };
  /**
   * Show conditional elements based on wanted state.
   */


  var toggleConditionalElements = function toggleConditionalElements(_ref3) {
    var id = _ref3.id,
        accepted = _ref3.accepted;
    var accepts = document.body.querySelectorAll("[".concat(ACCEPTED_STATE_ATTRIBUTE, "=\"").concat(id, "\"]"));
    var rejects = document.body.querySelectorAll("[".concat(REJECTED_STATE_ATTRIBUTE, "=\"").concat(id, "\"]"));

    _toConsumableArray(accepts).forEach(function (el) {
      return accepted ? showElement(el) : hideElement(el);
    });

    _toConsumableArray(rejects).forEach(function (el) {
      return accepted ? hideElement(el) : showElement(el);
    });
  };

  return {
    toggle: function toggle(preferences) {
      var cookies = config.get('cookies') || [];
      cookies.forEach(function (type) {
        var accepted = preferences.getState(type.id);
        toggleScripts({
          id: type.id,
          accepted: accepted
        });
        toggleConditionalElements({
          id: type.id,
          accepted: accepted
        });
        toggleConditionalIframes({
          id: type.id,
          accepted: accepted
        });
      });
    }
  };
};

export default DomToggler;